import React from 'react';
import Card from '@material-ui/core/Card';

class WeatherComponent extends React.Component {

    render(){
      const weatherImpactSummary = this.props.weatherData.weatherImpactSummary;
      return(
          <Card classes={{root: "weather-component-main"}}>
            <div className="container">
              <ul className="flex-list">
                <li className="flex-item location">{this.props.weatherData.location}</li>
                {weatherImpactSummary &&
                  <li className="flex-item">
                    <img src="https://d12of87xj1f8rc.cloudfront.net/email-images/dashboard/hot.png" alt="temp"/>
                    <span className="relative">{weatherImpactSummary}</span>
                  </li>}
              </ul>
            </div>
          </Card>
      )
    }
}

export default WeatherComponent;
